import { parseDuration } from "util/datetime";
import Indicador from "..";
import TMMEditFields from "./components/EditFields";
import { TMMParamFields } from "./components/ParamFields";
import tmmReport from "./reports";
import tmmReportSummary from "./reports/summary";
import { compareOp } from "util/lang"
import _ from 'lodash'
// import TMMGraficoPainel from "./components/TMMGraficoPainel";
// import TMMGraficoRelatorio from "./components/TMMGraficoRelatorio";

export default class TMM extends Indicador {
    static get fullName() {
        return "Tempo de Manobra de Máquinas";
    }

    static get abbrev() {
        return "TMM";
    }

    static paramFields(tipoIndicadorField = '') {
        return <TMMParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <TMMEditFields visita={visita} isNew={isNew} TipoClass={TipoClass} />
    }

    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <TMMGraficoPainel mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
    // }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return TMMGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return tmmReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return tmmReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!params) {
            return 0;
        }

        const meta = parseDuration(params.meta);
        const tempo = parseDuration(apontamento.tempoRegistrado);
        apontamento.tempoRegistradoSegundos = tempo

        if (meta && tempo) {
            apontamento.resto = (tempo - meta).toFixed(0);
        }

        return ((100 * f(apontamento.resto)) / meta).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta, apontamento, cliente) {
        if (!cliente) {
            throw new Error(
                "Este indicador necessita dos dados do cliente para calcular o status de conformidade"
            )
        }

        let cliParam
        if (cliente.getAllParams) {
            cliParam = cliente.getAllParams(this)
        } else if (cliente.params) {
            cliParam = _.get(cliente.params, this.abbrev.toLowerCase())
        }

        if (!cliParam || !cliParam.items || !cliParam.items.length) {
            return this.calcConformidadeStatusInverte(conformidade, 100, 30, 20, 10)
        }

        let itensStatus = cliParam.items || []

        let metaTime

        if (typeof meta === "number") {
            metaTime = meta
        } else {
            metaTime = parseDuration(meta)
        }

        let cofTime = metaTime * (parseFloat(conformidade) + 100) / 100

        const veri = (item) => {
            // console.log(`MIN: ${cofTime} ${item.sinalIntervaloMin} ${parseDuration(item.intervaloMin)} ? ${compareOp(cofTime, item.sinalIntervaloMin, parseDuration(item.intervaloMin))}`)
            // console.log(`MAX: ${cofTime} ${item.sinalIntervaloMax} ${parseDuration(item.intervaloMax)} ${compareOp(cofTime, item.sinalIntervaloMax, parseDuration(item.intervaloMax))}`)
            let result1, result2

            if (item.sinalIntervaloMin && parseDuration(item.intervaloMin)) {
                result1 = compareOp(cofTime, item.sinalIntervaloMin, parseDuration(item.intervaloMin))
            } else {
                result1 = true
            }

            if (item.sinalIntervaloMax && parseDuration(item.intervaloMax)) {
                result2 = compareOp(cofTime, item.sinalIntervaloMax, parseDuration(item.intervaloMax))
            } else {
                result2 = true
            }


            if (item.intervaloMin && !item.intervaloMax) {
                return result1
            } else if (item.intervaloMax && !item.intervaloMin) {
                return result2
            } else {
                return result1 && result2
            }
        }

        for (const item of itensStatus) {

            if (veri(item)) {
                // console.log('axo', item)
                return item.classificacao
            }


        }

        console.log("ERRO")
        return "ERROR"
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Implemento", field: "implemento.numeroFrotaImplemento", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Operador", field: "operador", width: 'auto' },


            { title: "Tempo Registrado (mm:ss) ", field: "tempoRegistrado", width: 'auto' },//
            { title: "Resto (segundos)", field: "resto", width: 'auto' },//


            {
                title: "% ", field: "conformidade", width: 38, getColor: a => {
                    // console.log("a", a)
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta, a, paramsCliente))
                }
            },

        ]
    }

    static getResultStr(apontamento) {
        return "Tempo Registrado (mm:ss): " + apontamento.tempoRegistrado +
            " e Resto (segundos): " + apontamento.resto
    }
}
